import { render, staticRenderFns } from "./SmartPicker.vue?vue&type=template&id=0064fa9a&scoped=true&"
import script from "./SmartPicker.vue?vue&type=script&lang=js&"
export * from "./SmartPicker.vue?vue&type=script&lang=js&"
import style0 from "./SmartPicker.vue?vue&type=style&index=0&id=0064fa9a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0064fa9a",
  null
  
)

export default component.exports